import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import '@icon-park/vue-next/styles/index.css'
import 'ant-design-vue/dist/antd.css'

import '@/assets/styles/global.scss'
import '@/assets/styles/antd.scss'

import {
  Button, Input, Modal, Select, Drawer, Spin, Alert, Tooltip,
  Dropdown, Menu, Checkbox, Divider, Popover, Switch, Radio, InputNumber, Slider,
  Table, Pagination,
} from 'ant-design-vue'

const app = createApp(App)

// ponytail: register all antd components globally - admin panel uses several.
// Could tree-shake later if bundle size matters.
;[Button, Input, Modal, Select, Drawer, Spin, Alert, Tooltip,
  Dropdown, Menu, Checkbox, Divider, Popover, Switch, Radio, InputNumber, Slider,
  Table, Pagination,
].forEach(c => app.component(c.name, c))

app.component('ButtonGroup', Button.Group)
app.component('SelectOption', Select.Option)
app.component('SelectOptGroup', Select.OptGroup)
app.component('RadioGroup', Radio.Group)
app.component('RadioButton', Radio.Button)
app.component('InputGroup', Input.Group)
app.component('TextArea', Input.TextArea)
app.component('MenuItem', Menu.Item)

app.use(createPinia())
app.use(router)
app.mount('#app')
